/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable } from '@angular/core'
import { ProfileMockApiRequestHandler } from './mock-api.request-handler'

@Injectable({
  providedIn: 'root',
})
export class ProfileMockApiService {
  requestHandlers: any

  /**
   * Constructor
   */
  constructor() {
    // Set the defaults
    this.requestHandlers = {
      delete: new Map<string, ProfileMockApiRequestHandler>(),
      get: new Map<string, ProfileMockApiRequestHandler>(),
      patch: new Map<string, ProfileMockApiRequestHandler>(),
      post: new Map<string, ProfileMockApiRequestHandler>(),
      put: new Map<string, ProfileMockApiRequestHandler>(),
      head: new Map<string, ProfileMockApiRequestHandler>(),
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register 'head' request handler
   *
   * @param url
   * @param delay
   */
  onHead(url: string, delay = 0): ProfileMockApiRequestHandler {
    return this._registerRequestHandler('head', url, delay)
  }

  /**
   * Register 'delete' request handler
   *
   * @param url
   * @param delay
   */
  onDelete(url: string, delay = 0): ProfileMockApiRequestHandler {
    return this._registerRequestHandler('delete', url, delay)
  }

  /**
   * Register 'get' request handler
   *
   * @param url
   * @param delay
   */
  onGet(url: string, delay = 0): ProfileMockApiRequestHandler {
    return this._registerRequestHandler('get', url, delay)
  }

  /**
   * Register 'patch' request handler
   *
   * @param url
   * @param delay
   */
  onPatch(url: string, delay = 0): ProfileMockApiRequestHandler {
    return this._registerRequestHandler('patch', url, delay)
  }

  /**
   * Register 'post' request handler
   *
   * @param url
   * @param delay
   */
  onPost(url: string, delay = 0): ProfileMockApiRequestHandler {
    return this._registerRequestHandler('post', url, delay)
  }

  /**
   * Register 'put' request handler
   *
   * @param url
   * @param delay
   */
  onPut(url: string, delay = 0): ProfileMockApiRequestHandler {
    return this._registerRequestHandler('put', url, delay)
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register a request handler
   *
   * @param requestType
   * @param url
   * @param delay
   * @private
   */
  private _registerRequestHandler(
    requestType: 'head' | 'post' | 'put' | 'get' | 'delete' | 'patch',
    url: string,
    delay: number,
  ): ProfileMockApiRequestHandler {
    // Create a new instance of ProfileMockApiRequestHandler
    const SignupMockHttp = new ProfileMockApiRequestHandler()

    // Store the url
    SignupMockHttp.url = url

    // Store the delay
    SignupMockHttp.delay = delay

    // Store the request handler to access them from the interceptor
    this.requestHandlers[requestType].set(url, SignupMockHttp)

    // Return the instance
    return SignupMockHttp
  }
}
